import {IFetchContext} from "@pg-mono/data-fetcher";

import {IRPStore} from "../../../app/rp_reducer";
import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {IAppDispatch} from "../../../store/store";
import {fetchDistrictsMonthlyStatsApi} from "../api/fetch_districts_monthly_stats";
import {getDistrictRegionsByParentApi} from "../api/get_district_regions_by_parent_api";
import {PricesViewType} from "../helpers/prices_view_type";
import {getDistrictsMonthlyStatsQuery} from "../utils/use_districts_price_data";

// Fills the RTK Query cache for the districts table and the district FAQ questions, so both render on the server.
// A failed request only hides the table - it never blocks the page, hence always `true`.
export const fetchPricesDistrictsData =
    (_ctx: IFetchContext<IRPRequestMeta, {regionSlug: string}>) => async (dispatch: IAppDispatch, getState: () => IRPStore) => {
        const {region, pricesAvailableDate} = getState().report.price;

        if (!region) {
            return true;
        }

        await Promise.all([
            dispatch(getDistrictRegionsByParentApi.endpoints.getDistrictRegionsByParent.initiate(region.id)),
            dispatch(
                fetchDistrictsMonthlyStatsApi.endpoints.getDistrictsMonthlyStats.initiate(
                    getDistrictsMonthlyStatsQuery(region.slug, PricesViewType.FLATS, pricesAvailableDate?.date)
                )
            )
        ]);

        return true;
    };
import {IFetchContext} from "@pg-mono/data-fetcher";

import {IRPStore} from "../../../app/rp_reducer";
import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {IAppDispatch} from "../../../store/store";
import {fetchDistrictsMonthlyStatsApi} from "../api/fetch_districts_monthly_stats";
import {getDistrictRegionsByParentApi} from "../api/get_district_regions_by_parent_api";
import {PricesViewType} from "../helpers/prices_view_type";
import {getDistrictsMonthlyStatsQuery} from "../utils/use_districts_price_data";

// Fills the RTK Query cache for the districts table and the district FAQ questions, so both render on the server.
// A failed request only hides the table - it never blocks the page, hence always `true`.
export const fetchPricesDistrictsData =
    (_ctx: IFetchContext<IRPRequestMeta, {regionSlug: string}>) => async (dispatch: IAppDispatch, getState: () => IRPStore) => {
        const {region, pricesAvailableDate} = getState().report.price;

        if (!region) {
            return true;
        }

        await Promise.all([
            dispatch(getDistrictRegionsByParentApi.endpoints.getDistrictRegionsByParent.initiate(region.id)),
            dispatch(
                fetchDistrictsMonthlyStatsApi.endpoints.getDistrictsMonthlyStats.initiate(
                    getDistrictsMonthlyStatsQuery(region.slug, PricesViewType.FLATS, pricesAvailableDate?.date)
                )
            )
        ]);

        return true;
    };
